var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { attrs: { type: "flex", justify: "space-between" } },
    [
      _c(
        "el-button",
        {
          attrs: { size: "small" },
          on: {
            click: function($event) {
              return _vm.$emit("cancel")
            }
          }
        },
        [_c("b", [_vm._v("Cancelar")])]
      ),
      _c(
        "el-button",
        {
          attrs: { disabled: !_vm.textModel, type: "success", size: "small" },
          on: {
            click: function($event) {
              return _vm.$emit("confirm")
            }
          }
        },
        [_c("b", [_vm._v(_vm._s(_vm.textButtonConfirm))])]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9fac3950", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9fac3950","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/AppUtilizarButtons.vue
// module id = null
// module chunks = 